import { SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { IRescheduleGameData } from "../types/reschedulegame";

import { alertActions } from "../../../features/alert/alertSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { rescheduleGame } from "../../../lib/api";
import { IGame, ILeague, ITeam } from "../../../types/api";

const useRescheduleGameHandlers = (
    isOnLeagueManagementPage: boolean,
    game: IGame,
    setSending: React.Dispatch<React.SetStateAction<boolean>>,
    setSchedule: React.Dispatch<React.SetStateAction<IGame[]>>,
    leagueId?: ILeague["id"],
    teamId?: ITeam["id"],
) => {
    const user = useAppSelector(state => state.auth.user);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const onSubmit: SubmitHandler<IRescheduleGameData> = async data => {
        setSending(true);
        try {
            const { schedule } = await rescheduleGame(
                data,
                user!.id,
                isOnLeagueManagementPage ? "league" : "team",
                game.league,
                teamId,
            );

            schedule.games && setSchedule(schedule.games);

            dispatch(
                alertActions.success({
                    title: `Game reschedule submitted successfully`,
                    persist: true,
                    dismissible: true,
                }),
            );

            isOnLeagueManagementPage
                ? game?.isPlayoff === 1
                    ? navigate(
                          `/league-management/league/${leagueId}/playoffSchedule`,
                      )
                    : navigate(`/league-management/league/${leagueId}/schedule`)
                : navigate(`/coachs-clubhouse/team/${teamId}/schedule`);
        } catch (error: any) {
            dispatch(
                alertActions.error({
                    title: `The server encountered an error submitting the reschedule request.`,
                    text: "If the problem continues, please reach out to an admin.",
                    dismissible: true,
                }),
            );
        } finally {
            setSending(false);
        }
    };

    return { onSubmit };
};

export default useRescheduleGameHandlers;
